import { Card, ChoiceList, FormLayout, Layout, Select, TextField } from '@shopify/polaris';
import { CsI18n } from "../../shared/csI18n/csI18n";
import Switch from "react-switch/index";
import { CsNonValidation as NV, CsValidation as V, CsValidationForm } from "../../shared/csValidationForm";
import HeadingHelper from "../../helpers/HeadingHelper";
import ChoiceHelper from "../../helpers/ChoiceHelper";
import React from "react";

const CustomerService = props => {
  const {
    workingDays, workingTimeStart, workingTimeEnd, afterSaleEmail, afterSalePhone,
    responseDuration, responseDurationUnit,
    handleChoiceListChange, handleChange,
  } = props;

  return (
    <FormLayout>
      <FormLayout.Group>
        <ChoiceList
          allowMultiple
          title={HeadingHelper.ltt('Customer service availabilities', 'company.explain.customer_service_availabilities')}
          choices={ChoiceHelper.choices(workingDays)}
          selected={ChoiceHelper.selected(workingDays)}
          onChange={handleChoiceListChange("workingDays")}
        />
      </FormLayout.Group>

      <FormLayout.Group
        condensed
        title={HeadingHelper.ltt('Working hours', 'company.explain.working_hours')}>
        <V>
          <TextField label={CsI18n.t("From")} type="time" step="1800"
                     value={workingTimeStart} onChange={handleChange('workingTimeStart')} />
          <V.Item rule="required" title={CsI18n.t("This field is required.")} />
        </V>
        <V>
          <TextField label={CsI18n.t("To")} type="time" step="1800"
                     value={workingTimeEnd} onChange={handleChange('workingTimeEnd')} />
          <V.Item rule="required" title={CsI18n.t("This field is required.")} />
        </V>
      </FormLayout.Group>

      <FormLayout.Group condensed>
        <V>
          <TextField
            label={CsI18n.t("After-sale email")}
            value={afterSaleEmail}
            onChange={handleChange('afterSaleEmail')} />
          <V.Item rule="required" title={CsI18n.t("This field is required.")} />
          <V.Item rule="email" title={CsI18n.t("Not a valid email.")} />
        </V>
        <V>
          <TextField
            label={CsI18n.t("After-sale phone")}
            value={afterSalePhone}
            onChange={handleChange('afterSalePhone')} />
          <V.Item rule="required" title={CsI18n.t("This field is required.")} />
          <V.Item rule="phone" title={CsI18n.t("Not a valid phone number.")} />
        </V>
      </FormLayout.Group>

      <FormLayout.Group condensed>
        <V>
          <TextField
            label={CsI18n.t("Maximum response time")} type="number" min={1}
            value={responseDuration} onChange={handleChange('responseDuration')} />
          <V.Item rule="required" title={CsI18n.t("This field is required.")} />
          <V.Item rule="number" title={CsI18n.t("Number only.")} />
          <V.Item rule="min" min={1} title={CsI18n.t("Too low number.")} />
        </V>
        <NV>
          <Select
            label={HeadingHelper.l('Maximum response unit',)}
            options={ChoiceHelper.choices(responseDurationUnit)}
            value={ChoiceHelper.selectedFirst(responseDurationUnit)}
            onChange={handleChoiceListChange('responseDurationUnit')} />
        </NV>
      </FormLayout.Group>
    </FormLayout>
  );
}

const Contact = props => {
  const { afterSaleEmail, afterSaleWebPage, handleChange } = props;

  return (
    <FormLayout>
      <FormLayout.Group>
        <V>
          <TextField
            label={CsI18n.t("After-sale email")}
            value={afterSaleEmail}
            onChange={handleChange('afterSaleEmail')} />
          <V.Item rule="required" title={CsI18n.t("This field is required.")} />
          <V.Item rule="email" title={CsI18n.t("Not a valid email.")} />
        </V>
        <V>
          <TextField
            label={CsI18n.t("After-sale webpage")}
            value={afterSaleWebPage}
            onChange={handleChange('afterSaleWebPage')} />
          <V.Item rule="required" title={CsI18n.t("This field is required.")} />
          <V.Item rule="websiteWtProtocol" title={CsI18n.t("Not a valid website.")} />
        </V>
      </FormLayout.Group>
    </FormLayout>
  );
}

const CompanyCustomerService = props => {
  const {
    customerServiceActive,
    workingDays, workingTimeStart, workingTimeEnd, afterSaleEmail, afterSalePhone,
    responseDuration, responseDurationUnit,
    afterSaleWebPage,
    handleChoiceListChange, handleChange,
    validatorClass,
  } = props;

  return (
    <Layout.AnnotatedSection
      title={CsI18n.t('company.annotate.title.customer_service')}
      description={CsI18n.t("company.annotate.desc.customer_service")}>
      <Card>
        <Card.Section>
          <FormLayout>
            <p><CsI18n>I’d like to inform my customers about our customer service availabilities</CsI18n></p>
            <Switch
              className="react-switch"
              onChange={handleChange('customerServiceActive')}
              checked={customerServiceActive}
              uncheckedIcon={false}
              checkedIcon={false}
              aria-label={CsI18n.t("I’d like to inform my customers about our customer service availabilities")}
            />
          </FormLayout>

          <CsValidationForm name={validatorClass} realtime={true}>
            {customerServiceActive ?
              <CustomerService
                workingDays={workingDays} workingTimeStart={workingTimeStart} workingTimeEnd={workingTimeEnd}
                afterSaleEmail={afterSaleEmail} afterSalePhone={afterSalePhone}
                responseDuration={responseDuration} responseDurationUnit={responseDurationUnit}
                handleChoiceListChange={handleChoiceListChange} handleChange={handleChange}
              /> :
              <Contact afterSaleEmail={afterSaleEmail}
                       afterSaleWebPage={afterSaleWebPage}
                       handleChange={handleChange} />
            }
          </CsValidationForm>
        </Card.Section>
      </Card>
    </Layout.AnnotatedSection>
  )
};

export default CompanyCustomerService;
